import React from 'react';

type Props = {
    chatId      :  ID
    fromUserId  :  ID
    message     :  string
    close       :  callback
    fadeTime    :  number
}

export default function ChatMessage(props: Props) {

    const openChat = () => {
        // gd.goTo('chat/'+props.chatId);
        gd.navigation.goToChat(props.chatId)
        props.close();
    };

    const fromUser = gd.session.users.get(props.fromUserId);

    const classes = Classes("notification", "h-100-percent", "chat-message")

    return (
        <div className={classes} style={{transition: "opacity " + props.fadeTime + "s"}}>
            <div className="flex-row-left-top">
                <div className="icon"></div>

                <div className="right-content">
                    <div className="ui5-txt-not-important-small m-b-8">{fromUser && fromUser.name}</div>
                    <div className="ui5-txt-less-important-small txt-truncate max-w-225 m-b-8">{props.message}</div>
                    <div className="flex-row-between-center">
                        <div className="flex-row-left-center">
                            <div className="flex-row-left-center link m-r-10" onClick={openChat}>
                                {/*<div className="i5-open-new-window m-r-5"></div>*/}
                                <div className="ui5-txt-link-tiny">View</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="close i5-delete" onClick={props.close}/>
        </div>
    )
}

